var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container crud-page-header"
  }, [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/requests"
    }
  }, [_vm._v("Requests")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('router-link', {
    attrs: {
      "to": "/associations"
    }
  }, [_vm._v(_vm._s(_vm.request.Association.Name))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "field crud-buttons is-grouped is-pulled-right"
  }, [_c('div', {
    staticClass: "control hide-mobile"
  }, [_c('button', {
    staticClass: "button is-text",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        _vm.putRequest(_vm.request)
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link hide-mobile",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": function($event) {
        _vm.openEmailModal()
      }
    }
  }, [_vm._v("\n            Email (PDF)\n            "), _c('i', {
    staticClass: "fa fa-lg fa-envelope-open",
    staticStyle: {
      "padding-left": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": function($event) {
        _vm.openEmailModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-envelope-open"
  })])]), _vm._v(" "), _c('span', [_c('a', {
    ref: "pdf",
    attrs: {
      "download": _vm.fileName,
      "href": _vm.pdflink
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-mobile",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_vm._v("\n            Download (PDF)\n            "), _c('i', {
    staticClass: "fa fa-lg fa-download",
    staticStyle: {
      "padding-left": "10px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button is-link hide-desktop",
    class: {
      'is-loading': _vm.isGeneratingPdf
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-download"
  })])])]), _vm._v(" "), _vm._m(0)]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container crud-body"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Requester Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.RequesterName),
      expression: "request.RequesterName"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "text",
      "placeholder": "Requester Name"
    },
    domProps: {
      "value": (_vm.request.RequesterName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "RequesterName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label is-small"
  }, [_vm._v("Requester Email")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.RequesterEmail),
      expression: "request.RequesterEmail"
    }],
    staticClass: "input is-small",
    attrs: {
      "type": "text",
      "placeholder": "Requester Email"
    },
    domProps: {
      "value": (_vm.request.RequesterEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "RequesterEmail", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns is-desktop"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('Accord24', {
    attrs: {
      "accord24": _vm.accord24,
      "requestViewer": true
    }
  }), _vm._v(" "), _c('Accord24', {
    ref: "accord",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "accord24": _vm.accord24,
      "readonly": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(_vm.request.Association.Attachments && _vm.request.Association.Attachments.length > 0) ? _c('div', {
    staticClass: "content is-small",
    staticStyle: {
      "margin-top": "20px",
      "max-width": "330px",
      "word-break": "break-all"
    }
  }, [_c('h4', [_vm._v("Additional Declarations")]), _vm._v(" "), _c('ul', {
    staticClass: "table",
    staticStyle: {
      "margin-top": "10px",
      "font-size": "13px",
      "margin-bottom": "0px"
    }
  }, _vm._l((_vm.request.Association.Attachments), function(attachment) {
    return _c('li', [_c('a', {
      attrs: {
        "href": attachment.downloadURL,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attachment.fileName))])])
  }))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showEmailModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Email Certificate")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  })]), _vm._v(" "), (!_vm.emailSuccess) ? _c('div', [_c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("To")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.to),
      expression: "emailData.to"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter a comma separated list of email address"
    },
    domProps: {
      "value": (_vm.emailData.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "to", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.emailInvalidTo) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n                  Valid email address is required\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("CC")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.cc),
      expression: "emailData.cc"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter a comma separated list of email address"
    },
    domProps: {
      "value": (_vm.emailData.cc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "cc", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.emailInvalidCc) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("\n                  Valid email address is required\n                ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-paperclip"
  }), _vm._v(" " + _vm._s(_vm.getAttachmentName()))])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailData.message),
      expression: "emailData.message"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Enter message"
    },
    domProps: {
      "value": (_vm.emailData.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailData, "message", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (_vm.emailError) ? _c('section', {
    staticClass: "modal-card-body"
  }, [_c('hr'), _vm._v(" Error sending email! Please try again or download PDF and send externally.\n          "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    class: {
      'is-loading': _vm.isSendingEmail
    },
    on: {
      "click": function($event) {
        _vm.sendEmailMessage(_vm.emailData)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (_vm.emailSuccess) ? _c('div', [_vm._m(1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.closeEmailModal()
      }
    }
  }, [_vm._v("Close")])])]) : _vm._e()])]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section hide-mobile"
  }, [_c('h3', {
    staticClass: "title is-5"
  }, [_vm._v("Request Information")]), _vm._v(" "), _c('hr')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._v("\n          Thank you, your email has been sent.\n          "), _c('br'), _vm._v(" "), _c('br')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddd80c9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/request/RequestViewer.vue
// module id = /WL8
// module chunks = 1